import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initState = {
  selectedEvidenceCount: 0,
  requiredEvidenceCount: 0,
  evidenceData: [],
  wordData: [],
  isShaking: false,
  currentWordLayouts: [],
  pendingWordLayouts: [],
  wordCountInItem: 0,
  pendingWordCount: 0,
  status: null,
};

const evidenceReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.DISABLE_EVIDENCE: {
      const { evidenceIndex } = payload;

      const newEvidenceData = [...state.evidenceData];
      const newEvidence = { ...newEvidenceData[evidenceIndex] };

      newEvidence.isDiscarded = true;
      newEvidence.isSelected = false;

      newEvidenceData[evidenceIndex] = newEvidence;

      const selectedEvidenceCount = state.selectedEvidenceCount - 1;

      return {
        ...state,
        evidenceData: newEvidenceData,
        selectedEvidenceCount,
      };
    }

    case REDUX_ACTIONS.UPDATE_EVIDENCE_STATUS: {
      return {
        ...state,
        status: payload.status,
      };
    }

    case REDUX_ACTIONS.HIGHLIGHT_EVIDENCE: {
      const { indexes } = payload;
      let selectedEvidenceCount = 0;

      const newEvidenceData = state.evidenceData.map((evidence) => {
        const isSelected = indexes.includes(evidence.evidenceIndex) || evidence.isSelected;
        selectedEvidenceCount = isSelected ? selectedEvidenceCount + 1 : selectedEvidenceCount;
        return {
          ...evidence,
          isSelected,
        };
      });

      return {
        ...state,
        evidenceData: newEvidenceData,
        selectedEvidenceCount,
      };
    }

    case REDUX_ACTIONS.TOGGLE_EVIDENCE_SELECTION: {
      const { evidenceIndex } = payload;

      const newEvidenceData = [...state.evidenceData];
      const newEvidence = { ...newEvidenceData[evidenceIndex] };

      newEvidence.isSelected = !newEvidence.isSelected;

      newEvidenceData[evidenceIndex] = newEvidence;

      const selectedEvidenceCount = newEvidence.isSelected ?
        state.selectedEvidenceCount + 1 : state.selectedEvidenceCount - 1;

      return {
        ...state,
        evidenceData: newEvidenceData,
        selectedEvidenceCount,
      };
    }

    case REDUX_ACTIONS.SET_IS_EVIDENCE_PANEL_SHAKING:
      return {
        ...state,
        isShaking: payload.isShaking,
      };

    case REDUX_ACTIONS.INITIALIZE_STANDARD_ITEM:
      return {
        ...state,
        selectedEvidenceCount: 0,
        requiredEvidenceCount: payload.requiredEvidenceCount,
        evidenceData: payload.evidenceData,
        rwEvidence: payload.rwEvidence,
        wordData: payload.wordData,
        currentWordLayouts: [],
        pendingWordLayouts: [],
        wordCountInItem: payload.wordCountInItem,
        pendingWordCount: 0,
        status: null,
      };

    case REDUX_ACTIONS.REGISTER_TAGGABLE_WORD_LAYOUT: {
      const pendingWordLayouts = [...state.pendingWordLayouts];
      const { groupIndex, layout: { x, y, width, height } } = payload;
      const { text } = state.evidenceData[groupIndex];
      // remove underscores at the beginning of accessibility text
      const accessibilityLabel = text && [...text][0] === '_' ? text.substring(1) : text;
      const newGroup = {
        groupIndex,
        accessibilityLabel,
        rows: [],
      };

      if (pendingWordLayouts[groupIndex] !== undefined) {
        newGroup.rows = [...pendingWordLayouts[groupIndex].rows];
      }

      const affectedRowIndex = newGroup.rows.findIndex(e => e.y === y);

      if (affectedRowIndex < 0) {
        newGroup.rows.push({ x, y, width, height });
      } else {
        const newRow = newGroup.rows[affectedRowIndex];
        newGroup.rows[affectedRowIndex] = {
          ...newRow,
          width: newRow.width + width,
          x: Math.min(newRow.x, x),
        };
      }

      pendingWordLayouts[groupIndex] = newGroup;

      const currentWordLayouts = state.pendingWordCount + 1 >= state.wordCountInItem
        ? pendingWordLayouts.filter(Boolean) // remove empty elements
        : state.currentWordLayouts;

      return {
        ...state,
        pendingWordLayouts,
        pendingWordCount: state.pendingWordCount + 1,
        currentWordLayouts,
      };
    }

    default:
      return state;
  }
};

export default evidenceReducer;
